import {
  Status,
  TimeLineItemStyles,
  TimeLineLeftBarGroupColors,
} from 'components/TimeLine'
import { TFunction } from 'i18next'
import {
  AccomodationType,
  CarType,
  FlightType,
  LicensePlateType,
  Maybe,
  Participant,
  Proving,
  ResourceBooking,
  TrackHotel,
  TransportType,
  VehicleType,
} from 'model'
import moment, { Moment } from 'moment'
import { IPersonaProps } from 'office-ui-fabric-react'
import shortid from 'shortid'
import { FilterObject } from 'views/BookingsView/AppletViewExtensions'
import { MainCategorySpan } from 'views/BookingsView/BookingsAppletTimeLine'

export interface HierarchyObj {
  key: string
  value: any
  children: any[]
}

export interface GroupObj {
  id: number
  title: string
  tip?: string
  type?: string
  stackItems?: boolean
  height?: number
}

export interface ItemObj {
  id: number
  group: number
  title: string
  tip: string
  start_time: Moment
  end_time: Moment
  transport?: any
  itemProps?: any
}

export const IncludeItemInRendering = (
  resource: ResourceBooking,
  resourcesCategories: string[],
  selectedResources: string[]
): boolean => {
  const categoryFound =
    resourcesCategories.includes(resource.resource.category!) ||
    resourcesCategories.includes(resource.resource.type!)

  if (categoryFound) {
    return true
  } else {
    return false
  }

  // if (
  //   (resource.resource.category! !== 'office' &&
  //     resource.resource.category! !== 'workshop') ||
  //   selectedResources.length === 0
  // ) {
  //   return true
  // }

  // if (
  //   categoryFound &&
  //   (resource.resource.category! === 'office' ||
  //     resource.resource.category! === 'workshop')
  // ) {
  //   return resource.resource.parent
  //     ? selectedResources.includes(resource.resource.parent!._id)
  //     : false
  // }

  // return false
}

// const getItemObjProps = () => {}
export const generateAvailabilityItems = (
  timeFrom: moment.Moment,
  timeTo: moment.Moment,
  groupMapping: Record<number, MainCategorySpan>,
  sourceItems: ItemObj[],
  groupItems: GroupObj[]
) => {
  const marks: any = []
  const markCount = moment(timeTo).diff(moment(timeFrom), 'days')
  const markTitles = new Array<number>(markCount)
  Object.keys(groupMapping).forEach((key, index) => {
    for (let i = 0; i < markCount; i++) {
      markTitles[i] = 0
    }
    const leafGroupsAvailability: {
      groupId: number
      dateFrom?: moment.Moment
      dateTo?: moment.Moment
    }[] = groupItems
      .filter(
        (group) =>
          group.id >= groupMapping[key].indexFrom &&
          group.id <= groupMapping[key].indexTo &&
          TimeLineLeftBarGroupColors[group.type!] !== '#5291DF' &&
          TimeLineLeftBarGroupColors[group.type!] !== '#B9D4F3'
      )
      .map((grFiltered) => ({ groupId: grFiltered.id }))

    const leafGroupsCount = leafGroupsAvailability.length
    const currentGroupItems = sourceItems.filter(
      (itemObj) =>
        itemObj.group >= groupMapping[key].indexFrom &&
        itemObj.group <= groupMapping[key].indexTo
    )

    currentGroupItems.forEach((itemElem) => {
      const elemIndexInGroup = leafGroupsAvailability.findIndex(
        (leafGroup) => leafGroup.groupId === itemElem.group
      )
      if (elemIndexInGroup !== -1) {
        leafGroupsAvailability[elemIndexInGroup].dateFrom =
          leafGroupsAvailability[elemIndexInGroup].dateFrom
            ? moment.min([
                moment(itemElem.start_time),
                moment(leafGroupsAvailability[elemIndexInGroup].dateFrom),
              ])
            : moment(itemElem.start_time)
        leafGroupsAvailability[elemIndexInGroup].dateTo =
          leafGroupsAvailability[elemIndexInGroup].dateTo
            ? moment.max([
                moment(itemElem.end_time),
                moment(leafGroupsAvailability[elemIndexInGroup].dateTo),
              ])
            : moment(itemElem.end_time)
      }
    })

    leafGroupsAvailability.forEach((leafGroup) => {
      if (leafGroup.dateFrom && leafGroup.dateTo) {
        const startIndex = moment(leafGroup.dateFrom).diff(
          moment(timeFrom),
          'days'
        )
        const endIndex = moment(leafGroup.dateTo).diff(moment(timeFrom), 'days')
        for (let i = startIndex; i <= endIndex; i++) {
          markTitles[i] = markTitles[i] + 1
        }
      }
    })

    for (let i = 0; i < markCount; i++) {
      const startTime = moment(timeFrom).startOf('day').add(i, 'days')
      const endTime = moment(timeFrom)
        .startOf('day')
        .add(i + 1, 'days')
      const markPercentage = markTitles[i] / (leafGroupsCount * 1.0)
      const markStyle =
        markPercentage <= 0.5
          ? TimeLineItemStyles.resourceAvailabilityGreen
          : markPercentage <= 0.8
          ? TimeLineItemStyles.resourceAvailabilityYellow
          : TimeLineItemStyles.resourceAvailabilityRed

      marks.push({
        id: shortid.generate(),
        title:
          markPercentage !== 0
            ? Math.trunc(markPercentage * 100).toString() + '%'
            : '',
        group: key,
        start_time: moment(startTime),
        end_time: moment(endTime),
        itemProps: markStyle,
      })
    }
  })
  return marks
}
export const getItems = (
  provings: Proving[] | undefined,
  groupsLookUpDict: { [id: string]: number },
  filter: FilterObject,
  t: TFunction
) => {
  const ritems: ItemObj[] = [] as ItemObj[]
  let dateFrom = moment()
  let dateTo = moment()
  if (provings && groupsLookUpDict) {
    provings.forEach((proving: Proving) => {
      if (proving) {
        const color = Status.find((item: any) => {
          return item.id === `${proving.status}`
        })
        if (proving.resourceBookings && proving.resourceBookings.length > 0) {
          proving.resourceBookings.forEach((resource: ResourceBooking) => {
            if (
              IncludeItemInRendering(
                resource,
                filter.resourceCategories,
                filter.resources
              )
            ) {
              const id = groupsLookUpDict[resource.resource._id]

              if (id) {
                const cdateFrom = moment(resource.dateFrom)
                const cdateTo = moment(resource.dateTo).endOf('day')

                if (dateFrom > cdateFrom) {
                  dateFrom = cdateFrom
                }

                if (dateTo < cdateTo) {
                  dateTo = cdateTo
                }

                if (cdateFrom === cdateTo) {
                  cdateTo.add(12, 'h')
                }
                let resBookingParticipantName = ''
                if (
                  resource.participantId &&
                  proving.participants &&
                  proving.participants.length !== 0
                ) {
                  const resParticipant = proving.participants.find(
                    (particip) => particip._id === resource.participantId
                  )
                  if (resParticipant && resParticipant.person) {
                    resBookingParticipantName = `\nTeilnehmer: ${resParticipant.person.name}`
                  }
                }
                const itemObj: ItemObj = {
                  id: ritems.length + 1,
                  group: id,
                  title: `${proving.id}\n${cdateFrom.format(
                    'dddd, DD. MMM YYYY'
                  )} - ${cdateTo.format('dddd, DD. MMM YYYY')}\n${
                    resource.resource.title
                  }\n${t(`enum.status.${proving.status}`)}\n${
                    proving!.provingGround!.title
                  }${resBookingParticipantName}`,
                  start_time: cdateFrom,
                  end_time: cdateTo,
                  itemProps: {
                    // resDetails will be used for router.navigate on Timeline item double-click
                    resDetails: {
                      pgid: proving.provingGround!._id,
                      id: resource.resource._id,
                      provingsList: true,
                      category: resource.resource.category,
                      type: resource.resource.type,
                      erpid: proving.id,
                    },
                    style: {
                      textAlign: 'center',
                      backgroundColor: color ? color.color : '',
                      color: 'white',
                      border: '1px solid #0F0F0F',
                    },
                  },
                } as ItemObj
                ritems.push(itemObj)
              }
            }
          })
        }
      }
    })
  }

  return { ritems, dateFrom, dateTo }
}

const getParticipantGroupTitle = (
  participant: Participant,
  t: TFunction
): string => {
  if (
    (!participant.person &&
      participant.unknownPerson &&
      participant.unknownPerson.isUnknown === true &&
      participant.unknownPerson.personType === 'user') ||
    (!participant.person &&
      participant.unknownPerson &&
      participant.unknownPerson.isUnknown === true &&
      participant.unknownPerson.personType === 'external')
  ) {
    return t('model.proving.participant.participantUnknown')
  } else if (
    (!participant.person &&
      participant.unknownPerson &&
      participant.unknownPerson.isUnknown === false &&
      participant.unknownPerson.personType === 'user') ||
    (!participant.person &&
      participant.unknownPerson &&
      participant.unknownPerson.isUnknown === false &&
      participant.unknownPerson.personType === 'external')
  ) {
    return `${participant.unknownPerson.surName}, ${participant.unknownPerson.firstName}`
  } else if (
    participant.unknownPerson &&
    participant.unknownPerson.isUnknown &&
    participant.unknownPerson.personType === 'worker'
  ) {
    return `${participant.percentage} % ${participant.unknownPerson.department}`
  } else if (
    participant.unknownPerson &&
    participant.unknownPerson.isUnknown &&
    participant.unknownPerson.personType === 'supplier'
  ) {
    return `${participant.unknownPerson.surName}, ${participant.unknownPerson.firstName} - ${participant.unknownPerson.supplier}`
  } else if (
    participant.unknownPerson &&
    !participant.unknownPerson.isUnknown &&
    participant.unknownPerson.personType === 'worker'
  ) {
    return participant && participant.person
      ? `${participant.percentage}% ${participant.person.name}`
      : ''
  } else {
    return participant && participant.person ? participant.person.name : ''
  }
}

export const getParticipant = (
  participant: Participant,
  groupIndex: number,
  itemIndex: number,
  t: TFunction
): { participantItem: ItemObj; participantGroup: GroupObj } => {
  const participantGroup: GroupObj = {
    id: groupIndex,
    title: getParticipantGroupTitle(participant, t),
    stackItems: true,
  } as GroupObj

  const participantItem = getParticipantObj(
    participant,
    groupIndex,
    itemIndex,
    t
  )

  return { participantItem, participantGroup }
}

export const getParticipants = (
  provings: Proving[] | undefined,
  persons: IPersonaProps[],
  groups: GroupObj[],
  items: ItemObj[],
  t: TFunction
) => {
  const groupsLookUpDict: { [id: string]: number } = {}

  if (persons && provings) {
    if (persons.length > 0) {
      const personObj: GroupObj = {
        id: groups.length + 1,
        title: t(`field.applet.timeline.persons`),
        type: 'Persons',
        stackItems: true,
      } as GroupObj
      groups.push(personObj)
    }

    persons.forEach((person: any) => {
      const groupObj: GroupObj = {
        id: groups.length + 1,
        title: `${person.text}`,
        stackItems: true,
      } as GroupObj
      groupsLookUpDict[`${person.userId}`] = groupObj.id
      groups.push(groupObj)
    })

    provings.forEach((proving: Proving) => {
      if (proving && proving.participants) {
        proving.participants.forEach((participant: Participant) => {
          const participantGroupId = participant.person
            ? groupsLookUpDict[participant.person._id]
            : null

          if (participantGroupId) {
            const participantItem = getParticipantObj(
              participant,
              participantGroupId,
              items.length + 1,
              t
            )
            items.push(participantItem)

            getFlight(
              participant,
              participantGroupId,
              items.length + 1,
              t
            ).forEach((flight: ItemObj) => {
              items.push(flight)
            })

            getTrackHotels(
              participant,
              participantGroupId,
              items.length + 1,
              t
            ).forEach((hotel: ItemObj) => {
              items.push(hotel)
            })

            getFerries(
              participant,
              participantGroupId,
              items.length + 1,
              t
            ).forEach((ferry: ItemObj) => {
              items.push(ferry)
            })
            // const vehicleTransportationToDays =
            //   proving.provingGround &&
            //   proving.provingGround.vehicleTransportToDays
            //     ? proving.provingGround.vehicleTransportToDays
            //     : 0
            // const vehicleTransportationFromDays =
            //   proving.provingGround &&
            //   proving.provingGround.vehicleTransportFromDays
            //     ? proving.provingGround.vehicleTransportFromDays
            //     : 0
            const result = getRentalCar(
              participant,
              participantGroupId,
              items.length + 1,
              t
            )

            if (result) {
              items.push(result)
            }
          }
        })
      }
    })
  }

  return { groups, items }
}

export const getParticipantObj = (
  participant: Participant,
  groupIndex: number,
  itemIndex: number,
  t: TFunction
): ItemObj => {
  const hasAccomodation =
    participant.accomodation &&
    participant.accomodation!.accomodationType !==
      AccomodationType.NoAccomodation
      ? true
      : false

  const showAccomodationTitle = hasAccomodation
    ? `${participant.accomodation!.accomodation!.title}` // +
    : 'Buchungszeitraum (keine Unterkunft erforderlich)'

  const participantItem: ItemObj = {
    id: itemIndex,
    group: groupIndex,
    title: showAccomodationTitle,
    start_time:
      participant.accomodation && participant.accomodation.dateFrom
        ? moment(participant.accomodation.dateFrom)
            .startOf('day')
            .add(12, 'hours')
        : moment(participant.dateFrom).startOf('day').add(12, 'hours'),
    end_time:
      participant.accomodation && participant.accomodation.dateTo
        ? moment(participant.accomodation.dateTo)
            .endOf('day')
            .subtract(12, 'hours')
        : moment(participant.dateTo).endOf('day').subtract(12, 'hours'),
    itemProps: hasAccomodation
      ? TimeLineItemStyles.accomodation
      : TimeLineItemStyles.participant,
  } as ItemObj

  return participantItem
}

export const getFlight = (
  participant: Participant,
  groupIndex: number,
  itemIndex: number,
  t: TFunction
) => {
  const flightItems: ItemObj[] = [] as ItemObj[]
  if (
    participant.flight &&
    participant.flight.flightType !== FlightType.NoFlight
  ) {
    // const flightTitle = participant.flight
    //   ? `${t(`enum.flight.flightType.${participant.flight.flightType}`)}  ${t(
    //       `enum.resourceRequirementStatus.${participant.flight.bookingStatus}`
    //     )}`
    //   : ''

    if (
      participant.flight.flightType === FlightType.OutboundFlight ||
      participant.flight.flightType === FlightType.Roundtrip
    ) {
      flightItems.push({
        id: itemIndex,
        group: groupIndex,
        title: 'Hinflug',
        start_time:
          participant.flight && participant.flight.outboundData
            ? moment(participant.flight.outboundData.departure)
            : moment(participant.dateFrom),
        end_time:
          participant.flight && participant.flight.outboundData
            ? moment(participant.flight.outboundData.departure).add(12, 'hours')
            : moment(participant.dateFrom).add(12, 'hours'),
        itemProps: TimeLineItemStyles.flight,
      } as ItemObj)
      itemIndex++
    }

    if (
      participant.flight.flightType === FlightType.ReturnFlight ||
      participant.flight.flightType === FlightType.Roundtrip
    ) {
      flightItems.push({
        id: itemIndex,
        group: groupIndex,
        title: 'Rückflug',
        start_time:
          participant.flight && participant.flight.returnData
            ? moment(participant.flight.returnData.departure).add(12, 'hours')
            : moment(participant.dateTo).add(12, 'hours'),
        end_time:
          participant.flight && participant.flight.returnData
            ? moment(participant.flight.returnData.departure).add(24, 'h')
            : moment(participant.dateTo).add(24, 'h'),
        itemProps: TimeLineItemStyles.flight,
      } as ItemObj)
    }
  }

  return flightItems
}

export const getTrackHotels = (
  participant: Participant,
  groupIndex: number,
  itemIndex: number,
  t: TFunction
) => {
  const trackhotelItems: ItemObj[] = [] as ItemObj[]
  let currentItemIndex = itemIndex
  if (participant.trackHotels && participant.trackHotels.outward) {
    participant.trackHotels.outward.forEach((hotel: Maybe<TrackHotel>) => {
      if (hotel && hotel.hotel) {
        trackhotelItems.push({
          id: currentItemIndex,
          group: groupIndex,
          title: hotel.hotel!.title!,
          start_time: moment(hotel.dateFrom),
          end_time: moment(hotel.dateTo).endOf('day'),
          itemProps: TimeLineItemStyles.trackHotel,
        } as ItemObj)
        currentItemIndex++
      }
    })
  }

  if (participant.trackHotels && participant.trackHotels.return) {
    participant.trackHotels.return.forEach((hotel: Maybe<TrackHotel>) => {
      if (hotel) {
        trackhotelItems.push({
          id: currentItemIndex,
          group: groupIndex,
          title: hotel.hotel!.title!,
          start_time: moment(hotel.dateFrom),
          end_time: moment(hotel.dateTo).endOf('day'),
          itemProps: TimeLineItemStyles.trackHotel,
        } as ItemObj)
        currentItemIndex++
      }
    })
  }

  return trackhotelItems
}

export const getFerries = (
  participant: Participant,
  groupIndex: number,
  itemIndex: number,
  t: TFunction
) => {
  const ferryItems: ItemObj[] = [] as ItemObj[]

  if (participant.ferry) {
    if (participant.ferry!.outward) {
      ferryItems.push({
        id: itemIndex,
        group: groupIndex,
        title: `${participant.ferry!.outward!.title} ${
          participant.ferry!.timeFrom
        }`,
        start_time: moment(participant.ferry!.dateFrom).set(
          'h',
          getIntFromTimeString(participant.ferry.timeFrom)
        ),
        end_time: moment(participant.ferry!.dateFrom).endOf('day'),
        itemProps: TimeLineItemStyles.ferry,
      } as ItemObj)
    }
    if (participant.ferry!.return) {
      ferryItems.push({
        id: itemIndex + 1,
        group: groupIndex,
        title: `${participant.ferry!.return!.title} ${
          participant.ferry!.timeTo
        }`,
        start_time: moment(participant.ferry!.dateTo!).set(
          'h',
          getIntFromTimeString(participant.ferry.timeTo)
        ),
        end_time: moment(participant.ferry!.dateTo!).endOf('day'),
        itemProps: TimeLineItemStyles.ferry,
      } as ItemObj)
    }
  }

  return ferryItems
}

const getIntFromTimeString = (time: string | undefined | null): number => {
  if (!time) {
    return 0
  }
  const [hourFrom] = time.split(':')
  const integer = parseInt(hourFrom, 10)
  return integer ? integer : 0
}

export const getRentalCar = (
  participant: Participant,
  groupIndex: number,
  itemIndex: number,
  t: TFunction
) => {
  const rental =
    participant.rentalCar && participant.rentalCar.carType !== CarType.None
      ? ({
          id: itemIndex,
          group: groupIndex,
          title: t(`enum.rentalCar.${participant.rentalCar!.carType}`),
          start_time: moment(participant.rentalCar!.dateFrom),
          end_time: moment(participant.rentalCar!.dateTo).endOf('day'),
          itemProps: TimeLineItemStyles.rentalCar,
        } as ItemObj)
      : null

  return rental
}

export const getGroupObj = (
  text: string,
  groupCount: number,
  typ?: string
): GroupObj => {
  const groupObj: GroupObj = {
    id: groupCount,
    title: text,
    type: typ ? typ : 'noType',
    stackItems: true,
  } as GroupObj

  return groupObj
}

export const GetRenderGroups = (
  groupHierarchy: HierarchyObj[] | undefined,
  resourcesCategories: string[],
  t: TFunction
): { resourceGroups: GroupObj[]; groupsLookUp: { [id: string]: number } } => {
  const resourceGroups: GroupObj[] = [] as GroupObj[]
  const groupsLookUp: { [id: string]: number } = {}

  if (groupHierarchy && groupHierarchy.length > 0) {
    groupHierarchy.forEach((main: HierarchyObj) => {
      const iterateChildren = (obj: any) => {
        if (obj.children && obj.children.length > 0) {
          const resourceGroupLabel = getGroupObj(
            `${obj.value.title}`,
            resourceGroups.length,
            obj.value.__typename
          )

          resourceGroups.push(resourceGroupLabel)
          groupsLookUp[obj.key] = resourceGroupLabel.id
          obj.children.forEach((nextObj: any) => {
            iterateChildren(nextObj)
          })
        } else {
          const resourceGroupItem = getGroupObj(
            obj.title ? obj.title : 'tbd',
            resourceGroups.length,
            obj.__typename
          )
          resourceGroups.push(resourceGroupItem)
          groupsLookUp[obj._id] = resourceGroupItem.id
        }
      }

      iterateChildren(main)
    })
  }

  return { resourceGroups, groupsLookUp }
}
export const getVehicleTransportationItems = (
  vehicleItem: ItemObj,
  itemIndex: number,
  groupIndex: number,
  vehicleTransportationToDays: number,
  vehicleTransportationFromDays: number
) => {
  const transpItems: { itemTo?: ItemObj; itemFrom?: ItemObj } = {}
  if (
    vehicleTransportationToDays !== 0 &&
    ((vehicleItem.transport &&
      vehicleItem.transport.transportType ===
        TransportType.OutboundAndReturnTransport) ||
      (vehicleItem.transport &&
        vehicleItem.transport.transportType ===
          TransportType.OutboundTransport))
  ) {
    itemIndex = itemIndex + 1
    const itemTo: ItemObj = {
      id: itemIndex,
      group: groupIndex,
      title: `Hintransport`,
      start_time: moment(vehicleItem.start_time).subtract(
        vehicleTransportationToDays,
        'days'
      ),
      end_time: moment(vehicleItem.start_time),
      itemProps: TimeLineItemStyles.carTransportation,
    } as ItemObj
    transpItems.itemTo = itemTo
  }
  if (
    vehicleTransportationFromDays !== 0 &&
    ((vehicleItem.transport &&
      vehicleItem.transport.transportType ===
        TransportType.OutboundAndReturnTransport) ||
      (vehicleItem.transport &&
        vehicleItem.transport.transportType === TransportType.ReturnTransport))
  ) {
    itemIndex = itemIndex + 1
    const itemFrom: ItemObj = {
      id: itemIndex,
      group: groupIndex,
      title: `Rücktransport`,
      start_time: moment(vehicleItem.end_time),
      end_time: moment(vehicleItem.end_time).add(
        vehicleTransportationFromDays,
        'days'
      ),
      itemProps: TimeLineItemStyles.carTransportation,
    } as ItemObj
    transpItems.itemFrom = itemFrom
  }
  return transpItems
}
export const getVehicle = (
  vehicle: any,
  groupIndex: number,
  itemIndex: number,
  t: TFunction
): { item: ItemObj; group: GroupObj } => {
  const label = vehicle.unknown
    ? t('model.proving.vehicle.vehicleUnknown.long')
    : vehicle.type === VehicleType.Internal
    ? (vehicle.label || (vehicle.eqVehicle && vehicle.eqVehicle.label) || '')
    : vehicle.labelExternal

  let licensePlate = ''
  if (
    vehicle.licensePlateType &&
    vehicle.licensePlateType === LicensePlateType.Unknown
  ) {
    licensePlate = t('model.proving.vehicle.licensePlateUnknown')
  }
  if (
    vehicle.licensePlateType &&
    vehicle.licensePlateType === LicensePlateType.NoRegistration
  ) {
    licensePlate = t('model.proving.vehicle.licensePlateNoRegistration')
  }
  if (vehicle.unknown) {
    licensePlate = t('model.proving.vehicle.vehicleUnknown.short')
  }
  const group: GroupObj = {
    id: groupIndex,
    title: label,
    stackItems: true,
  } as GroupObj

  const item: ItemObj = {
    id: itemIndex,
    group: groupIndex,
    title: `${label} ${licensePlate}`,
    start_time: moment(vehicle.dateFrom).startOf('day'),
    end_time: moment(vehicle.dateTo).endOf('day'),
    transport: vehicle.transport,
    itemProps:
      vehicle.type === VehicleType.External
        ? TimeLineItemStyles.rentalCar
        : TimeLineItemStyles.cars,
  } as ItemObj

  return { item, group }
}
